<div class="video">
  <div class="video__overlay" [class.is--hidden]="state === 1">
    <img [src]="getYoutubePoster()" [alt]="videoAltText" loading="lazy" />

    <button class="button button-icon button--primary button--lg" aria-label="Video afspelen" (click)="playVideo()">
      <fstr-icon anchor="icon-play" *ngIf="state !== 1 && state !== 3"></fstr-icon>
      <fstr-icon anchor="icon-loading" class="anim--spinning" *ngIf="state === 3"></fstr-icon>
    </button>
  </div>

  <fstr-youtube-player
    (ready)="onPlayerReady($event)"
    (change)="onPlayerChange($event)"
    #youtube
    [src]="url"
    [config]="youtubeConfig"
  ></fstr-youtube-player>
</div>
